export default {
  pageTitle: '勤務先管理',
  basicInfo: '基本信息',

  // 表单字段
  name: '名称',
  postalCode: '邮政编码',
  prefecture: '都道府县',
  detailedAddress: '详细地址',
  address: '地址',
  nearestStation: '最近车站',
  phone: '电话号码',
  businessHours: '营业时间',
  businessHoursDescription: '营业时间说明',
  constitute: '勤務先人员构成',
  images: '图片',
  lastEditTime: '最近编辑时间',
  addTime: '添加时间',
  addedBy: '添加人',
  addDate: '添加日期',

  // 按钮和操作
  addDepartment: '添加勤務先',
  detailTitle: '勤務先详情',
  editTitle: '编辑勤務先',

  // 占位符
  inputPlaceholder: '请输入',
  constitutePlaceholder: '请输入',
  imageHint: '限 jpg/jpeg/png/webp 格式，单个文件需小于 10 MB，不超过 6 张。职位发布到 App 端时可使用这些图片。',
  selectPlaceholder: '请选择',

  // 验证信息
  validation: {
    nameRequired: '请输入名称',
    nameDuplicate: '输入的勤務先名称已被注册',
    postalCodeRequired: '请输入邮政编码',
    postalCodeHalfWidth: '邮政编码请输入半角数字',
    phoneRequired: '请输入电话号码',
    addressRequired: '请输入地址',
    addressPrefectureRequired: '请选择都道府县',
    addressCityRequired: '请选择市区町村',
    addressDetailRequired: '请输入町名丁目番地号等',
    businessHoursRequired: '请选择营业时间',
    imagesRequired: '请至少上传一张图片',
  },

  // 时间选择器
  timeRangePicker: {
    startTimePlaceholder: '开始时间',
    endTimePlaceholder: '结束时间',
    sameDay: '当日',
    nextDay: '次日',
  },

  // 空状态
  emptyStates: {
    noData: {
      title: '暂无数据',
      description: '还没有创建勤務先'
    }
  },
  deleteDialog: {
    title: '确认删除勤務先',
    content: '删除后不可恢复，确认删除勤務先「 {name}」吗？',
    warningContent: '勤務先「 {name}」下发布过职位，暂不支持删除。'
  }
};
